import { traverseSchema } from "../../Helpers/Functions/universalSchema"
import { JobStatus } from "../API/JobModel"
import { PartialBy } from "../Utility/PartialBy"
import { TaskStatus } from "../API/TaskModel"
import {
    AnnotationOutputSchemaItem,
    SchemaForm,
    findUniversalSchemaTypeByField,
    annotationOutputTypes,
    annotationTypeFields
} from "universal-schema/lib"
import { UniversalSchemaType } from "universal-schema/lib/0.0.4"

/**
 * Find or generate a value that conforms with AnnotationOutputSchemaItem
 *
 * If provided status is completed, it tries to find from job output,
 * otherwise tries to generate empty value from job input.
 */
export function findAnnotationOutput(
    outputSchema: SchemaForm,
    status: JobStatus | TaskStatus,
    response: unknown
): PartialBy<AnnotationOutputSchemaItem, "schema_instance"> | undefined {
    return traverseSchema<AnnotationOutputSchemaItem | undefined>(
        outputSchema,
        response,
        (passed, { uiSchema, schema }, data) => {
            const uiField = uiSchema["ui:field"]

            if (annotationTypeFields.includes(uiField as any)) {
                return status === JobStatus.COMPLETED ||
                    status === TaskStatus.COMPLETED
                    ? ({
                          type: UniversalSchemaType.UNIVERSAL,
                          uiSchema,
                          schema_instance: data,
                          schema
                      } as any)
                    : undefined
            }

            const type =
                typeof uiField === "string"
                    ? findUniversalSchemaTypeByField(uiField)
                    : undefined

            if (type === undefined || !annotationOutputTypes.includes(type)) {
                return passed
            }

            if (passed !== undefined) {
                // return undefined if more than one annotation output type is found
                return undefined
            }

            if (
                status === JobStatus.COMPLETED ||
                status === TaskStatus.COMPLETED
            ) {
                return {
                    type,
                    schema_instance: data
                }
            }

            return undefined
        },
        undefined
    )
}
